import { IconHistory, IconHome, IconMenu } from '@douyinfe/semi-icons';
import { Button, Dropdown, Layout, Nav, Space } from '../ui/semi';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { AccountMenu } from '../components/AccountMenu';
import { usePlatformAuth } from './PlatformAuthContext';

const { Header, Sider, Content } = Layout;

export function PlatformShell() {
  const auth = usePlatformAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  if (!auth.token || !auth.operator) return <Navigate to="/platform/login" replace />;
  const selected = location.pathname.startsWith('/platform/audit-logs')
    ? '/platform/audit-logs'
    : location.pathname.startsWith('/platform/login-logs')
    ? '/platform/login-logs'
    : '/platform/tenants';
  const menuItems = [
    ...(auth.operator.role === 'PLATFORM_ADMIN'
      ? [
          { itemKey: '/platform/tenants', icon: <IconHome />, text: '租户管理', description: '租户、品牌、套餐与域名配置' },
        ]
      : []),
    { itemKey: '/platform/audit-logs', icon: <IconHistory />, text: '操作日志', description: '查看平台管理操作与详情' },
    { itemKey: '/platform/login-logs', icon: <IconHistory />, text: '登录日志', description: '查看平台登录审计' },
  ];
  const siderWidth = collapsed ? 72 : 248;
  return (
    <Layout className={collapsed ? 'app-shell platform-shell app-shell-collapsed' : 'app-shell platform-shell'}>
      <Sider style={{ width: siderWidth, flex: `0 0 ${siderWidth}px` }} className={collapsed ? 'app-sider platform-sider is-collapsed' : 'app-sider platform-sider'}>
        <Nav
          className="app-navigation"
          style={{ height: '100%' }}
          selectedKeys={[selected]}
          items={menuItems}
          isCollapsed={collapsed}
          onCollapseChange={setCollapsed}
          header={{
            logo: <span className="app-logo-mark">Δ</span>,
            text: <span className="app-logo-copy"><strong>Delta</strong><small>平台控制台</small></span>,
          }}
          footer={{ collapseButton: true, collapseText: (isCollapsed) => isCollapsed ? '展开导航' : '收起导航' }}
          onSelect={({ itemKey }) => navigate(String(itemKey))}
        />
      </Sider>
      <Layout>
        <Header className="app-header">
          <div className="header-context">
            <span className="mobile-nav">
              <Dropdown
                trigger="click"
                menu={menuItems.map((item) => ({ node: 'item' as const, name: String(item.text), onClick: () => navigate(String(item.itemKey)) }))}
              >
                <Button theme="borderless" icon={<IconMenu />} aria-label="打开平台导航" />
              </Dropdown>
            </span>
          </div>
          <Space className="header-tools" spacing={12}>
            <AccountMenu
              name={auth.operator.displayName}
              caption={auth.operator.role}
              initials={auth.operator.displayName.slice(0, 1).toUpperCase()}
              onLogout={auth.logout}
            />
          </Space>
        </Header>
        <Content className="app-content"><Outlet /></Content>
      </Layout>
    </Layout>
  );
}
